import React from 'react'
import { tokenBoxStyle as styles } from './token.tailwind.js'

// Card/ Box
const TokenBox = ({ token }) => {
  return (
    <div className={styles.outer_box}>
      {/* Top right component */}
      <div className={styles.top_right_outer_circle}>
        {/* Inner filled circle */}
        <div className={styles.top_right_inner_circle}>
          {/* Image/Logo */}
          <img src={token?.image} alt={"img " + token?.id || ""} className={styles.top_right_img}  />
        </div>
      </div>

      {/* Main content */}
      <h1 className={styles.heading}>{token?.heading}</h1>
      <p className={styles.description}>{token?.description}</p>
    </div>
  )
}

export default TokenBox